import axios from 'axios';

export function update(testimonials, reportType) {
  return axios.put('/api/testimonial', {
    reportType,
    testimonials,
  });
}

export function remove(id) {
  axios.delete('/api/testimonial/' + id);
}

export function list() {
  return axios.get('/api/testimonial');
}